import { httpServices } from './client';

/**
 * Per-user preferences (`/llm/me/preferences`), stored on the server so they
 * follow the user across browsers. Contract:
 * rakuyaku-app-api/docs/v2/preferences-and-export-api.md §3.
 */

export interface Preferences {
  text_size: 'small' | 'medium' | 'large';
  theme: 'light' | 'dark' | 'system';
  language: 'ja' | 'en';
  width: 'standard' | 'wide';
  follow_latest: boolean;
  reduce_motion: boolean;
  send_key: 'ctrl_enter' | 'enter';
}

export interface PreferencesResponse {
  success: boolean;
  data?: Preferences;
  /** False until the user saves for the first time (data = defaults). */
  stored?: boolean;
  updated_at?: string | null;
  error?: string;
  status?: number;
}

/** GET /llm/me/preferences */
export const getPreferences = () =>
  httpServices.llmService.get<PreferencesResponse>('/me/preferences');

/** PUT /llm/me/preferences with any subset; the response is the full set. */
export const putPreferences = (patch: Partial<Preferences>) =>
  httpServices.llmService.put<PreferencesResponse>('/me/preferences', patch);
